//

import MockERC20File from '@artifacts/contracts/mocks/MockERC20.sol/MockERC20.json'
import ServiceConfigurationAbiFile from '@artifacts/contracts/ServiceConfigurationV5.sol/ServiceConfigurationV5.json'

import ServiceConfigurationV3AbiFile from '@artifacts/contracts/ServiceConfigurationV3.sol/ServiceConfigurationV3.json'
import Erc20AbiFile from '@artifacts/@openzeppelin/contracts/token/ERC20/ERC20.sol/ERC20.json'
import ToSAcceptanceRegistryAbiFile from '@artifacts/contracts/ToSAcceptanceRegistry.sol/ToSAcceptanceRegistry.json'
import PoolAbiFile from '@artifacts/contracts/Pool.sol/Pool.json'
import IPoolBaseAbiFile from '@artifacts/contracts/interfaces/IPoolBase.sol/IPoolBase.json'
import PoolFlexAbiFile from '@artifacts/contracts/PoolFlex.sol/PoolFlex.json'
import QueryLibAbiFile from '@artifacts/contracts/libraries/QueryLib.sol/QueryLib.json'
import PoolControllerAbiFile from '@artifacts/contracts/controllers/PoolController.sol/PoolController.json'
import PoolControllerFlexAbiFile from '@artifacts/contracts/controllers/PoolControllerFlex.sol/PoolControllerFlex.json'
import WithdrawControllerFactoryAbiFile from '@artifacts/contracts/factories/WithdrawControllerFactory.sol/WithdrawControllerFactory.json'
import WithdrawDepositControllerFactoryFlexAbiFile from '@artifacts/contracts/factories/WithdrawDepositControllerFactoryFlex.sol/WithdrawDepositControllerFactoryFlex.json'
import PoolFactoryAbiFile from '@artifacts/contracts/factories/PoolFactory.sol/PoolFactory.json'
import PoolFactoryFlexAbiFile from '@artifacts/contracts/factories/PoolFactoryFlex.sol/PoolFactoryFlex.json'
import PoolLibAbiFile from '@artifacts/contracts/libraries/PoolLib.sol/PoolLib.json'
import LoanFactoryAbiFile from '@artifacts/contracts/factories/LoanFactory.sol/LoanFactory.json'

import PoolControllerFactoryAbiFile from '@artifacts/contracts/factories/PoolControllerFactory.sol/PoolControllerFactory.json'
import PoolControllerFactoryFlexAbiFile from '@artifacts/contracts/factories/PoolControllerFactoryFlex.sol/PoolControllerFactoryFlex.json'
import PoolAccessControlFactoryAbiFile from '@artifacts/contracts/factories/PoolAccessControlFactory.sol/PoolAccessControlFactory.json'
import VaultFactoryAbiFile from '@artifacts/contracts/factories/VaultFactory.sol/VaultFactory.json'
import LoanLibAbiFile from '@artifacts/contracts/libraries/LoanLib.sol/LoanLib.json'
import PoolLibFlexAbiFile from '@artifacts/contracts/libraries/PoolLibFlex.sol/PoolLibFlex.json'
import PoolAccessControlAbiFile from '@artifacts/contracts/PoolAccessControl.sol/PoolAccessControl.json'
import WithdrawControllerAbiFile from '@artifacts/contracts/controllers/WithdrawController.sol/WithdrawController.json'
import WithdrawDepositControllerFlexAbiFile from '@artifacts/contracts/controllers/WithdrawDepositControllerFlex.sol/WithdrawDepositControllerFlex.json'
import PoolRegistryAbiFile from '@artifacts/contracts/PoolRegistry.sol/PoolRegistry.json'
import LoanAbiFile from '@artifacts/contracts/Loan.sol/Loan.json'

import PoolFactoryDynamicAbiFile from '@artifacts/contracts/factories/PoolFactoryDynamic.sol/PoolFactoryDynamic.json'
import PoolDynamicAbiFile from '@artifacts/contracts/PoolDynamic.sol/PoolDynamic.json'
import PoolControllerDynamicAbiFile from '@artifacts/contracts/controllers/PoolControllerDynamic.sol/PoolControllerDynamic.json'

import LYTPoolFactoryAbiFile from '@artifacts/contracts/factories/LYTPoolFactory.sol/LYTPoolFactory.json'
import LYTPoolAbiFile from '@artifacts/contracts/LYTPool.sol/LYTPool.json'
import LYTPoolControllerAbiFile from '@artifacts/contracts/controllers/LYTPoolController.sol/LYTPoolController.json'
import LYTPoolServiceConfigurationAbiFile from '@artifacts/contracts/LYTPoolServiceConfiguration.sol/LYTPoolServiceConfiguration.json'

export const ServiceConfigurationAbi = ServiceConfigurationAbiFile.abi

export const ServiceConfigurationV3Abi = ServiceConfigurationV3AbiFile.abi
export const Erc20Abi = Erc20AbiFile.abi
export const MockERC20Abi = MockERC20File.abi
export const PoolRegistryAbi = PoolRegistryAbiFile.abi
export const LoanAbi = LoanAbiFile.abi

export const ToSAcceptanceRegistryAbi = ToSAcceptanceRegistryAbiFile.abi
export const PoolAbi = PoolAbiFile.abi
export const IPoolBaseAbi = IPoolBaseAbiFile.abi
export const PoolFlexAbi = PoolFlexAbiFile.abi
export const QueryLibAbi = QueryLibAbiFile.abi
export const PoolControllerAbi = PoolControllerAbiFile.abi
export const PoolControllerFlexAbi = PoolControllerFlexAbiFile.abi
export const WithdrawControllerFactoryAbi = WithdrawControllerFactoryAbiFile.abi
export const WithdrawDepositControllerFactoryFlexAbi = WithdrawDepositControllerFactoryFlexAbiFile.abi
export const PoolFactoryAbi = PoolFactoryAbiFile.abi
export const PoolFactoryFlexAbi = PoolFactoryFlexAbiFile.abi
export const PoolLibAbi = PoolLibAbiFile.abi
export const LoanFactoryAbi = LoanFactoryAbiFile.abi

export const PoolControllerFactoryAbi = PoolControllerFactoryAbiFile.abi
export const PoolControllerFactoryFlexAbi = PoolControllerFactoryFlexAbiFile.abi
export const PoolAccessControlFactoryAbi = PoolAccessControlFactoryAbiFile.abi
export const VaultFactoryAbi = VaultFactoryAbiFile.abi
export const LoanLibAbi = LoanLibAbiFile.abi
export const PoolLibFlexAbi = PoolLibFlexAbiFile.abi
export const PoolAccessControlAbi = PoolAccessControlAbiFile.abi
export const WithdrawControllerAbi = WithdrawControllerAbiFile.abi
export const WithdrawDepositControllerFlexAbi = WithdrawDepositControllerFlexAbiFile.abi

export const PoolDynamicAbi = PoolDynamicAbiFile.abi
export const PoolFactoryDynamicAbi = PoolFactoryDynamicAbiFile.abi
export const PoolControllerDynamicAbi = PoolControllerDynamicAbiFile.abi

export const LYTPoolAbi = LYTPoolAbiFile.abi
export const LYTPoolFactoryAbi = LYTPoolFactoryAbiFile.abi
export const LYTPoolControllerAbi = LYTPoolControllerAbiFile.abi
export const LYTPoolServiceConfigurationAbi = LYTPoolServiceConfigurationAbiFile.abi
